import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SimplePagination.css';
import { Pagination } from 'react-bootstrap';

class SimplePagination extends Component {
  static propTypes = {
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
    total: PropTypes.number.isRequired,
    visiblePages: PropTypes.number,
    onPageChange: PropTypes.func,
  };

  static defaultProps = {
    currentPage: 1,
    pageSize: 25,
    visiblePages: 10,
  };

  handlePrev = (disabled) => {
    if (!disabled) {
      if (this.props.onPageChange) {
        this.props.onPageChange(this.props.currentPage - 1);
      }
    }
  };

  handleNext = (disabled) => {
    if (!disabled) {
      if (this.props.onPageChange) {
        this.props.onPageChange(this.props.currentPage + 1);
      }
    }
  };

  handlePage = (pageNumber) => {
    if (this.props.onPageChange && this.props.currentPage !== pageNumber) {
      this.props.onPageChange(pageNumber);
    }
  };

  handleFirst = (disabled) => {
    if (!disabled) {
      this.props.onPageChange(1);
    }
  };

  handleLast = (disabled) => {
    if (!disabled) {
      this.props.onPageChange(this.numberOfPages);
    }
  };

  render() {
    this.numberOfPages = Math.ceil(this.props.total / this.props.pageSize);
    this.pages = this.createPages();

    const morePagesThanVisible = this.numberOfPages > this.props.visiblePages;
    return (
      <div className="simple-pagination">
        <Pagination>
          <Pagination.First
            className="pagination-first"
            disabled={
              this.numberOfPages <= this.props.visiblePages ||
              this.props.currentPage === 1
            }
            onClick={this.handleFirst.bind(
              this,
              this.numberOfPages <= this.props.visiblePages ||
                this.props.currentPage === 1
            )}
          />
          <Pagination.Prev
            className="pagination-prev"
            disabled={this.props.currentPage === 1}
            onClick={this.handlePrev.bind(this, this.props.currentPage === 1)}
          />
          {morePagesThanVisible && <Pagination.Ellipsis disabled={true} />}
          {this.pages.map((page, index) => {
            return (
              <Pagination.Item
                key={index}
                active={page.active}
                className="pagination-item"
                onClick={this.handlePage.bind(this, page.number)}
              >
                {page.number}
              </Pagination.Item>
            );
          })}
          {morePagesThanVisible && <Pagination.Ellipsis disabled={true} />}
          <Pagination.Next
            className="pagination-next"
            disabled={
              this.props.currentPage === this.numberOfPages ||
              this.numberOfPages === 0
            }
            onClick={this.handleNext.bind(
              this,
              this.props.currentPage === this.numberOfPages ||
                this.numberOfPages === 0
            )}
          />
          <Pagination.Last
            className="pagination-last"
            disabled={
              this.numberOfPages <= this.props.visiblePages ||
              this.props.currentPage === this.numberOfPages ||
              this.numberOfPages === 0
            }
            onClick={this.handleLast.bind(
              this,
              this.numberOfPages <= this.props.visiblePages ||
                this.props.currentPage === this.numberOfPages ||
                this.numberOfPages === 0
            )}
          />
        </Pagination>
      </div>
    );
  }

  createPages() {
    let pages = [];
    for (let i = 0; i < this.numberOfPages; i++) {
      pages.push({
        number: i + 1,
        active: i + 1 === this.props.currentPage,
      });
    }

    if (this.numberOfPages > this.props.visiblePages) {
      // We have to filter values
      const pageIndex = this.props.currentPage - 1;
      const leftLimit = Math.floor((this.props.visiblePages - 1) / 2);
      const rightLimit = Math.ceil((this.props.visiblePages - 1) / 2);

      let limits = {
        firstIndex: pageIndex - leftLimit,
        lastIndex: pageIndex + rightLimit,
      };
      limits = this.calculateIndexes(pages.length, limits);

      pages = pages.filter(
        (item, index) => index >= limits.firstIndex && index <= limits.lastIndex
      );
    }

    return pages;
  }

  calculateIndexes(total, limits) {
    if (limits.firstIndex >= 0) {
      if (limits.lastIndex < total) {
        return limits;
      } else {
        limits.firstIndex = limits.firstIndex - 1;
        limits.lastIndex = limits.lastIndex - 1;
        return this.calculateIndexes(total, limits);
      }
    } else {
      limits.firstIndex = limits.firstIndex + 1;
      limits.lastIndex = limits.lastIndex + 1;
      return this.calculateIndexes(total, limits);
    }
  }
}

export default SimplePagination;



// WEBPACK FOOTER //
// ./src/components/shared/pagination/SimplePagination.js